import React from 'react'
import CS_FAQ_comp from './CS_FAQ_comp'
import CS_Mobile_view_faq_comp from './CS_Mobile_view_faq_comp'
import ffffff from '../image/ffffff.avif'

function CS_FAQ_page() {
  return (
    <div>
      {/* --------------------Mobile View-------------------- */}
      <div className="mt-5 d-sm-block d-md-none">
        <div className="container">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h1 className="display-6">Frequently Asked Questions</h1>
              <p className="fs-6 pt-1">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="FAQ_img">
                <img src={ffffff}></img>
              </div>
            </div>
            <div className="col-md-12">
              <CS_Mobile_view_faq_comp />
            </div>
          </div>
        </div>
      </div>

      {/* -----------------Desktop View---------------------- */}
      <div className="mt-5 d-none d-md-block">
        <div className="container pt-5">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h1 className="display-6">Frequently Asked Questions</h1>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
            <div className='FAQ_img'>
              <img src={ffffff}></img>
            </div>
            </div>
            <div className="col-md-7">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <CS_FAQ_comp />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CS_FAQ_page
